<app-header [isHeaderMenu]="true"></app-header>
<ion-content>
  <app-hero></app-hero>

  <ion-accordion-group>
    @for (p of appPages; track p) {
      @if (p.childs) {
        <ion-accordion>
          <ion-item slot="header" detail="false">
            <ion-label>{{ (p.title).toUpperCase() }}</ion-label>
          </ion-item>
          <div slot="content">
            @for (c of p.childs; track c) {
              <ion-menu-toggle auto-hide="false">
                @if (showItem(c)) {
                  <ion-item
                    detail="false"
                    routerDirection="root"
                    [routerLink]="[c.url]"
                    routerLinkActive="active"
                    >
                    <ion-label>{{ (c.title).toUpperCase() }}</ion-label>
                  </ion-item>
                }
              </ion-menu-toggle>
            }
          </div>
        </ion-accordion>
      }
      @if (!p.childs) {
        <ion-menu-toggle auto-hide="false">
          <ion-item
            detail="false"
            routerDirection="root"
            [routerLink]="[p.url]"
            routerLinkActive="selected"
            >
            <ion-label>{{ (p.title.toUpperCase()) }}</ion-label>
          </ion-item>
        </ion-menu-toggle>
      }
    }
    <ion-accordion>
      <!-- solves border bug -->
    </ion-accordion>
  </ion-accordion-group>
</ion-content>
